import {React, useState} from "react";
import styled from "@emotion/styled/macro";
import { Link } from "react-router-dom";
import { 
    Grid2 as Grid,
    Typography,
    Button,
    Slide,
    Dialog,
    DialogContent,
    IconButton
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';


import ROUTES from '../../constants/routes';

const StyledGridContainer = styled(Grid)`
    height: 100%;
    align-items: center;
    font-family: poppins;
    min-width: 200px;
    margin: 1vh auto;
    margin-top: 0;
`;
const StyledCallToActionGridItem = styled(Grid)`
    margin: 7.5vh auto;
    max-width: 33vw;
    min-width: 300px;
    text-align: center;
`;
const StyledCallToActionText = styled(Typography)`
    font-family: poppins;
    font-weight: bold;
    margin-top: 2.5vh;
    margin-bottom: 5vh;
    pointer-events: none;
`;
const StyledCallToActionButton = styled(Button)`
    margin: 1rem 1rem;
    background-color: black;
    font-family: poppins;

    &:hover {
        bottom: 1px;
        right: 1px;
        box-shadow: 3px 4px 3px rgba(0, 0, 0, 0.25);
    }
    &:active {
        top: 1px;
        left: 1px;
        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.25);
    }
`;
const StyledHiringManagersDialog = styled(Dialog)`
    height: 100%;
    width: 100%;
    .MuiDialog-paper::-webkit-scrollbar {
        display: none;
    }
`;
const StyledHiringManagersDialogContent = styled(DialogContent)`
    text-align: center;
    padding: 10px 10px;
`;
const StyledHiringManagersDialogCloseButton = styled(IconButton)`
    position: absolute;
    transition: all 0.15s;
    &:hover {
        scale: 1.10;
        color: red;
    }
    &:active {
        scale: 1.00;
        color: red;
    }
`;
const responsiveDialogCloseButton = {
    top: {
        xs: "0"
    },
    right: {
        xs: "0",
        sm: "0",
        md: "0",
        lg: "0"
    },
    '&:active': {
        top: {
            xs: "1px",
            sm: "1px",
            md: "1px",
            lg: "1px"
        }
    }
};
const StyledHiringManagersDialogCloseIcon = styled(CloseIcon)`
    height: 32px;
    width: 32px;
`;
const responsiveDialogCloseIcon = {
    color: {
        xs: "gray",
        sm: "gray",
        md: "gray"
    },
    '&:hover': {
        color: {
            xs: "red",
            sm: "red",
            md: "red"
        }
    },
    '&:active': {
        color: {
            xs: "red",
            sm: "red",
            md: "red"
        }
    },
    height: {
        xs: "24px",
        sm: "24px",
        md: "28px",
        lg: "32px"
    },
    width: {
        xs: "24px",
        sm: "24px",
        md: "28px",
        lg: "32px"
    }
};
const StyledHiringManagersModalHeading = styled(Typography)`
    font-family: poppins;
    margin: 20px auto;
`;
const StyledHiringManagersModalBody = styled(Typography)`
    font-family: poppins;
    margin: 20px 40px;
`;
const StyledHiringManagersModalSignature = styled(Typography)`
    font-family: Oooh Baby;
    margin: 20px 40px;
    font-size: 32px;
    pointer-events: none;
`;

const CallToAction = () => {
    const [hiringManagersModalOpen, setHiringManagersModalOpen] = useState(false);
    const handleOpenHiringManagersModal = () => {
        setHiringManagersModalOpen(true);
    }
    const handleCloseHiringManagersModal = () => {
        setHiringManagersModalOpen(false);
    }
    return (
        <StyledGridContainer container rowSpacing={3}>
            <StyledHiringManagersDialog open={hiringManagersModalOpen} onClose={handleCloseHiringManagersModal} scroll="body" TransitionComponent={Slide} TransitionProps={{direction: "up"}} >
                <StyledHiringManagersDialogContent>
                    <StyledHiringManagersDialogCloseButton onClick={handleCloseHiringManagersModal} variant="contained" sx={responsiveDialogCloseButton}>
                        <StyledHiringManagersDialogCloseIcon sx={responsiveDialogCloseIcon}/>
                    </StyledHiringManagersDialogCloseButton>
                    <StyledHiringManagersModalHeading variant="h5">To Hiring Managers et al</StyledHiringManagersModalHeading>
                        <StyledHiringManagersModalBody variant="body1">{`
                            With this portfolio I am an open book. As someone who has experience being the interviewer, my biggest challenge had always been uncovering the true essence of a candidate and understanding who they really are and their capabilities. After all, you only have at most a few hours getting to know a given candidate and that's hardly enough time to truly get to know somebody.
                        `}</StyledHiringManagersModalBody>
                        <StyledHiringManagersModalBody variant="body1">{`
                            My wishes are that this portfolio site will save us both time and also, when we interview, we'll have more interesting/relevant topics to discuss. I'm compressing my entire life/career into this portfolio so I can show you an all-encompassing look into the honest who/why/what of me and then we can decide if I'm the right fit.
                        `}</StyledHiringManagersModalBody>
                        <StyledHiringManagersModalSignature variant="body1">{`
                            - Keane Le
                        `}</StyledHiringManagersModalSignature>
                </StyledHiringManagersDialogContent>
            </StyledHiringManagersDialog>
            <StyledCallToActionGridItem size={12}>
                <StyledCallToActionText variant="h4">
                    Hello! I&apos;m Keane Le: Cloud Architect / Disciple of Technology
                </StyledCallToActionText>
                <StyledCallToActionButton variant="contained" onClick={handleOpenHiringManagersModal}>
                    To Hiring Managers
                </StyledCallToActionButton>
                <StyledCallToActionButton variant="contained" component={Link} to={ROUTES.HISTORICAL_TIMELINE}>
                    See my historical timeline
                </StyledCallToActionButton>
            </StyledCallToActionGridItem>
        </StyledGridContainer>
    )
}

export default CallToAction;